import React, { Component } from "react";
import classNames from "classnames";
import DateFnsUtils from "@date-io/date-fns";
import { withStyles } from "@material-ui/core";
import { KeyboardDatePicker as MuiDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { FormField } from "react-form";
import FormHelperText from "@material-ui/core/FormHelperText";

const styles = (theme) => ({
    bootstrapInput: {
        borderRadius: 4,
        border: "1px solid #979797",
        padding: "6px 8px",
        width: "calc(100% - 24px)",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        "&:focus": {
            borderColor: theme.palette.secondary.light,
            boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
        },
        backgroundColor: "#fff",
        fontSize: "15px",
        fontWeight: 500,
        color: "#262626 !important",
        "&::placeholder": {
            color: "#666666",
            opacity: 1,
        },
    },
    bootstrapInputError: {
        "& input": {
            border: "1px solid #f44336",
        },
    },
    rootLabelShrink: {
        marginLeft: 0,
        marginTop: -2,
        marginBottom: -12,
        position: "inherit",
        whiteSpace: "nowrap",
        overflowX: "hidden",
        overflowY: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
    },
    rootLabelShrinkExpansionPanel: {
        //for help with label to offset header
        marginLeft: 0,
        marginTop: -7,
        whiteSpace: "nowrap",
        overflowX: "hidden",
        overflowY: "visible",
        textOverflow: "ellipsis",
        width: "100%",
    },
    disabled: {
        backgroundColor: "#EEEEEE",
    },
    button: {
        "& button": {
            border: 0,
        },
        "& button:hover": {
            backgroundColor: "rgba(60, 138, 199, 0.08)",
        },
        "& .MuiPickersToolbar-toolbar": {
            backgroundColor: "#2845D6",
        },
        "& .MuiPickersToolbarText-toolbarTxt": {
            color: "rgba(255, 255, 255, 0.87)",
        },
        "& .MuiPickersCalendarHeader-dayLabel": {
            color: "#555555",
        },
        "& .MuiPickersDay-daySelected": {
            backgroundColor: "#2845D6",
            "&:hover": {
                backgroundColor: "#2845D6",
            },
        },
        "& .MuiPickersCalendarHeader-switchHeader button:first-child::after": {
            content: '"Previous"',
            fontSize: "0.75rem",
            marginLeft: 4,
        },
        "& .MuiPickersCalendarHeader-switchHeader button:last-child::before": {
            content: '"Next"',
            fontSize: "0.75rem",
            marginRight: 4,
        },
    },
});

const toolbarStyles = {
    toolbar: {
        backgroundColor: "#2845D6",
        padding: "16px 24px",
        color: "white",
    },
    heading: {
        margin: 0,
        padding: 0,
        fontWeight: "normal",
    },
    yearBtn: {
        background: "none",
        border: 0,
        padding: 0,
        cursor: "pointer",
        display: "block",
        fontSize: "1rem",
        lineHeight: 1.4,
    },
    dateBtn: {
        background: "none",
        border: 0,
        padding: 0,
        cursor: "pointer",
        display: "block",
        fontSize: "1.75rem",
        fontWeight: "bold",
        lineHeight: 1.2,
    },
};

function DatePickerAccessibleToolbar({ date, openView, setOpenView }) {
    if (!date) return null;
    const year = date.getFullYear();
    const dateStr = date.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
    const selectedColor = "rgb(255, 255, 255)";
    const unselectedColor = "rgb(255, 255, 255)";
    return (
        <div style={toolbarStyles.toolbar}>
            <h2 style={toolbarStyles.heading}>
                <button
                    style={{ ...toolbarStyles.yearBtn, color: openView === "year" ? selectedColor : unselectedColor }}
                    onClick={() => setOpenView("year")}
                >
                    {year}
                </button>
                <button
                    style={{ ...toolbarStyles.dateBtn, color: openView === "date" ? selectedColor : unselectedColor }}
                    onClick={() => setOpenView("date")}
                >
                    {dateStr}
                </button>
            </h2>
        </div>
    );
}

class AccDatePickerWrapper extends Component {
    // The first commit of Material-UI
    //const [selectedDate, setSelectedDate] = React.useState(new Date());

    state = { lastValidDisplayValue: null };

    handleDateChange = (date) => {
        const { fieldApi, eventHandle } = this.props;
        const { setValue, setError } = fieldApi;

        if (date) {
            if (!isNaN(date)) {
                var formatDate =
                    date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1 < 10 ? "0" : "") +
                    (date.getMonth() + 1) +
                    "-" +
                    (date.getDate() < 10 ? "0" : "") +
                    date.getDate() +
                    " 12:00:00";

                const year = date.getFullYear();
                const currentYear = new Date().getFullYear();
                if (year < currentYear - 100 || year > currentYear + 100) {
                    // Valid date but year is out of the ±100 year range
                    setValue("Invalid Date");
                    setError("Invalid Year");
                } else {
                    setValue(formatDate);
                    setError(null);
                    this.setState({ lastValidDisplayValue: formatDate });
                    if (eventHandle) eventHandle(date.toLocaleDateString());
                }
            } else {
                setValue("Invalid Date");
                setError("Invalid Date");
            }
        } else if (!date) {
            setValue("");
            setError(null);
            this.setState({ lastValidDisplayValue: null });
            if (eventHandle) eventHandle("Required");
        }
    };

    handleBlur = () => {
        const { fieldApi } = this.props;
        const { getValue, setError } = fieldApi;
        const value = getValue();

        if (value && value !== "None" && value !== "" && value !== "Invalid Date") {
            const parsedDate = new Date(value);
            if (isNaN(parsedDate)) {
                setError("Invalid Date");
            } else {
                const year = parsedDate.getFullYear();
                const currentYear = new Date().getFullYear();
                if (year.toString().length < 4 || year < currentYear - 100 || year > currentYear + 100) {
                    setError("Invalid Year");
                } else {
                    setError(null);
                }
            }
        } else if (!value || value === "" || value === "None") {
            setError(null);
        }
        // if value === "Invalid Date", leave the existing error as-is
        fieldApi.setTouched();
    };

    validate = () => {
        const { fieldApi } = this.props;
        const { getValue, setError } = fieldApi;
        const value = getValue();

        // Form submission validation - check for incomplete/invalid dates
        if (value && value !== "None" && value !== "") {
            const parsedDate = new Date(value);
            if (isNaN(parsedDate)) {
                setError("Invalid Date");
                return "Invalid Date";
            } else if (parsedDate.getFullYear().toString().length < 4) {
                setError("Invalid Year");
                return "Invalid Year";
            }
        }
        return null;
    };

    componentDidMount() {
        const { autoPopulateAnotherDate, eventHandle, fieldApi } = this.props;
        if (autoPopulateAnotherDate) eventHandle("find other date");
        const initialValue = fieldApi.getValue();
        if (initialValue && initialValue !== "None" && initialValue !== "" && initialValue !== "Invalid Date") {
            this.setState({ lastValidDisplayValue: initialValue });
        }
    }

    render() {
        const { helperText, fieldApi, classes, disabled, eventHandle, required, expansionPanel, id, field, ...rest } = this.props;
        const inputId = id || (field ? `datepicker-${field}` : `datepicker-unknown`);
        const labelId = `${inputId}-label`;
        const isStringLabel = typeof rest.label === "string";
        const labelText = isStringLabel
            ? rest.label
            : field
            ? field.replace(/_/g, " ")
            : "Date input";

        const { getValue, getError, getWarning, getSuccess, setTouched } = fieldApi;
        var rawValue = getValue(),
            error = getError(),
            warning = getWarning(),
            success = getSuccess(),
            hasError = !!error,
            errorText = error || warning || success || helperText;

        let InputProps = {};
        InputProps["disableUnderline"] = true;
        InputProps["classes"] = {
            input: classNames(classes.bootstrapInput, disabled && classes.disabled),
            error: classes.bootstrapInputError,
        };

        var value = rawValue === "Invalid Date" ? this.state.lastValidDisplayValue : rawValue;

        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <MuiDatePicker
                    ToolbarComponent={DatePickerAccessibleToolbar}
                    id={inputId}
                    value={value == null || value === "" || value === " " || value === "None" ? null : value}
                    // initialFocusedDate={value ? value : null}
                    disabled={disabled}
                    required={rest.required}
                    onChange={this.handleDateChange}
                    onBlur={this.handleBlur}
                    format="MM/dd/yyyy"
                    autoOk
                    InputProps={InputProps}
                    inputProps={isStringLabel
                        ? { placeholder: "MM/DD/YYYY" }
                        : { "aria-label": labelText, "aria-labelledby": labelId, placeholder: "MM/DD/YYYY" }
                    }
                    InputLabelProps={{
                        shrink: true,
                        id: labelId,
                        htmlFor: inputId,
                        classes: {
                            shrink: !expansionPanel ? classes.rootLabelShrink : classes.rootLabelShrinkExpansionPanel,
                        },
                    }}
                    emptyLabel=""
                    okLabel={null}
                    cancelLabel={null}
                    error={hasError}
                    helperText={errorText}
                    DialogProps={{ className: classes.button }}
                    {...rest}
                    KeyboardButtonProps={{ ...(rest.KeyboardButtonProps || {}), "aria-label": `Choose date for ${labelText}` }}
                    leftArrowButtonProps={{ ...(rest.leftArrowButtonProps || {}), "aria-label": "Previous month" }}
                    rightArrowButtonProps={{ ...(rest.rightArrowButtonProps || {}), "aria-label": "Next month" }}
                />
                {required && !hasError && <FormHelperText style={{ marginTop: -1 }}>Required</FormHelperText>}
            </MuiPickersUtilsProvider>
        );
    }
}
AccDatePickerWrapper.displayName = "AccDatePickerWrapper";
const AccDatePickerr = FormField(AccDatePickerWrapper);

export default withStyles(styles)(AccDatePickerr);
